import React from 'react'
import { ReactComponent as Eye } from '../../../../assets/Visibility.svg'
import { ReactComponent as EyeOff } from '../../../../assets/eye-off.svg'
import {
  IconButton,
  InputAdornment,
  type SxProps,
  TextField,
  type TextFieldProps,
  type Theme
} from '@mui/material'

interface CustomPasswordTextFieldProps {
  id: string
  variant?: TextFieldProps['variant']
  placeholder: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  sx?: SxProps<Theme>
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  disabled?: boolean
}

export function CustomPasswordTextField (props: CustomPasswordTextFieldProps): JSX.Element {
  const [showValue, setShowValue] = React.useState(false)

  return (
    <TextField
      id={props.id}
      type={showValue ? 'text' : 'password'}
      variant={props.variant ?? 'outlined'}
      placeholder={props.placeholder}
      InputLabelProps={{
        disabled: true
      }}
      disabled={props.disabled}
      inputProps={props.inputProps}
      value={props.value}
      onChange={props.onChange}
      size='small'
      autoComplete='off'
      className={props.className ?? ''}
      sx={{
        '& input::-ms-reveal, & input::-ms-clear': {
          display: 'none'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #ffffff54 !important'
        },
        '& .MuiOutlinedInput-root': {
          color: '#fff !important'
        },
        ...props.sx
      }}
      InputProps={{
        endAdornment:
          <InputAdornment position='end'>
            <IconButton
              edge='end'
              aria-label={showValue ? 'hide password' : 'show password'}
              data-testid='password-toggle'
              disabled={props.disabled}
              onMouseDown={(e) => { e.preventDefault() }}
              onMouseUp={(e) => { e.preventDefault() }}
              onClick={() => { setShowValue((prev) => !prev) }}
            >
              {showValue ? <EyeOff /> : <Eye />}
            </IconButton>
          </InputAdornment>
      }}
    />
  )
}
